import{ useState } from "react";
import React from "react";
import Banner from "../Banner/Banner";
import './Contact.css'



export function Contact (){
    const [name,setName]=useState(""); 
    const [email,setEmail]=useState(""); 
    const [number,setNumber]=useState(""); 
    const changeName = (e)=>{
        setName(e.target.value)
    }
    const changeEmail = (e)=>{
        setEmail(e.target.value)
    }
    const changeNumber = (e)=>{
        setNumber(e.target.value)
    }
    const formHandler =(event)=>{
        event.preventDefault();
        setName("");
        setEmail("");
        setNumber("")
    }
    const submitForm =()=>{
        if(number!=null && email!=null && number!=null){
            alert('Form Submit')
            
        }
        else{
            alert('Form Field')
        }
    }
    return(

            <section className="contact-us">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6 col-md-6">
                            <form onSubmit={formHandler}>
                                <div className="form">
                                    <input placeholder="Your Name" type="text" onChange={changeName} value={name} required/>
                                </div>
                                <div className="form">
                                    <input placeholder="Your Email" type="email" onChange={changeEmail} value={email} required/>
                                </div>
                                <div className="form">
                                    <input placeholder="Phone Number"type="text" onChange={changeNumber} value={number} required />
                                </div>
                                <select>
                                    <option>Select Department</option>
                                    <option>One</option>
                                    <option>Two</option>
                                    <option>Three</option>
                                </select>
                                <div className="form-Massage">
                                    <textarea placeholder="Massage" />
                                </div>
                                <button onClick={submitForm}>Send</button>
                            </form>
                        </div>
                        <div className="col-lg-6 col-md-6">
                            <div className="side">
                                <div className="overlay">
                                    <h3>Contact Us For Any Informations</h3>
                                    <li><i className="fa-solid fa-map-location-dot"></i>Location</li>
                                    <hr/>
                                    <p>2005 Stokes Isle Apt. 896, Venaville 10010, USA</p>
                                    <li><i className="fa-solid fa-address-card"></i>Email & Phone</li>
                                    <hr />
                                    <p>omarm3hmoud@gmail.com</p>
                                    <p>(+20) 1016407214</p>
                                    <li><i className="fa-solid fa-globe"></i>Follow Us</li>
                                    <hr />
                                    <div className="links">
                                        <ul>
                                            <li><a href="#"><i className="fa-brands fa-instagram"></i></a></li>
                                            <li><a href="#"><i className="fa-brands fa-facebook"></i></a></li>
                                            <li><a href="#"><i className="fa-brands fa-x-twitter"></i></a></li>
                                            <li><a href="#"><i className="fa-brands fa-linkedin"></i></a></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
    )
}
function contact(){
    return(
        <>
            <Banner title="Contact Us" smtitle="contact" />
            <Contact/>
        </>
    )
}
export default contact;